module.exports = __webpack_public_path__ + "static/img/course-c.65b1edef.png";